import { FC } from "preact/compat";
import { RawHtmlProps } from "./interfaces";

// @TODO: sanitize html

const RawHtml: FC<RawHtmlProps> = ({
    html,
    as: Component = "div",
    className,
}) => (
    <Component
        className={className}
        dangerouslySetInnerHTML={{ __html: html }}
    />
);

export default RawHtml;
